import type { CfFailureReason } from '@prerender/prerender-shared/FE';
import { CfFlowResponse } from '../api/cloudflareFlowApi';
import { cfFailureCopyFor } from '../cfFailureCopy';
import { CF_SETUP_STEPS } from '../components/cfSetupSteps';

export type DeploymentFailureRow = {
  /** `null` leaves the step to the one that actually failed. */
  step: string | null;
  error: string;
};

const labelOf = (key: string): string | null =>
  CF_SETUP_STEPS.find((row) => row.key === key)?.label ?? null;

const FIXED_STEP_ROW: Readonly<Partial<Record<CfFailureReason, string>>> = {
  route_collision: 'route_attach',
  worker_limit_reached: 'worker_upload',
  site_unreachable_after_proxy: 'ensure_proxied',
};

/** The `[step]` and `[error]` of the PRD's deployment row for this flow's failure. */
export function deploymentFailureRowFor(flow: CfFlowResponse): DeploymentFailureRow {
  const reason = flow.errorDetail?.reason;
  const fixedRow = reason === undefined ? undefined : FIXED_STEP_ROW[reason as CfFailureReason];
  const { message } = cfFailureCopyFor(reason, flow.domain);

  return { step: fixedRow ? labelOf(fixedRow) : null, error: flow.errorDetail?.nexusError ?? message };
}
